import React, { useEffect, useCity, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addCity } from 'slices/citySlice';
import { updateCity } from 'slices/citySlice';
import { fetchCitys } from 'slices/citySlice';
import toast from 'react-hot-toast';
import { citySelector } from 'slices/citySlice';
import { setError } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { stateSelector } from 'slices/stateSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchStates } from 'slices/stateSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const AddCityForm = ({ item, handleClose, callback,statusPerm }) => {
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = React.useState({
    name: '',
    state_id: ''
  })
  const { error, loader } = useSelector(citySelector);
  const { state: states } = useSelector(stateSelector);


  useEffect(() => {

    setValue('name', item?.name || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(fetchStates())
    return () => {
      dispatch(setError({}))

      setValue("state_id", "");
      setValue("name", "")
      setValue("status", 1)
      // Clean up on unmount
      // This is where you would dispatch an action to remove the hospital from the store
    }

  }, [item])

  
  useEffect(() => {
    if (states?.length > 0) {
      if (item?.state?.id)
        setValue("state_id", item?.state?.id)
      else
        setValue("state_id", states ? states[0]?.id : null)
    }
  }, [item, states])



  // #region States dropdown
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        label: item?.state?.name || "",
        value: item?.state?.id || ""
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])

  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className:"successToast",
      })
      dispatch(fetchCitys())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
       toast.error(message,
        {
          className:"errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateCity(data, item?.id, submitCallback));
    } else
      dispatch(addCity(data, submitCallback));

  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>


        <div className="row-primary">
          <h2>City Name *</h2>

          <Controller
            name="name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='City Name' required {...field} />}

          />
        </div>


        <div className="row-primary">
          <h2>Select State *</h2>

          <Controller
            name="state_id"
            control={control}
            rules={{
              required: "Please select a state"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
              <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterStates}
                  loadOptions={filteredStatesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setfilterStates(obj)
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                />

              {errors?.state_id?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.state_id?.message} />
                </div>
              }

            </div>
            }
          />
        </div>
        {statusPerm &&
          <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <Controller
              name="status"
              control={control}
              required
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CustomSwitch
                  labelText="active"
                  checked={field.value == 1 ? true : false}
                  handleChange={(checked) => field.onChange(checked ? 1 : 0)}

                />
              )}
            />
          </div>
        }
        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />

        </div>
      </form>

    </div>
  )
}

const AddCity = ({ item, onClose, callback ,statusPerm}) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} City</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddCityForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCity
